// extracted by mini-css-extract-plugin
export default {"header":"RelatedLinks_header__Na-Qt","list":"RelatedLinks_list__FtXU9"};